import PropTypes from 'prop-types';

import checkImage from '@app/assets/icons/icon-check.svg';
import UploadedFileInformation from '@app/components/UploadedFileInformation';

import './LogoImageInfoView.scss';

const propTypes = {
  base64: PropTypes.string,
  fileName: PropTypes.string,
  onLoad: PropTypes.func,
  onReset: PropTypes.func,
};

const defaultProps = {
  base64: '',
  fileName: '',
  onLoad() {},
  onReset() {},
};

function LogoImageInfoView({ base64, fileName, onLoad, onReset }) {
  return (
    <div className="box-10x align-center">
      <img alt="체크 아이콘" src={checkImage} />
      <h3>로고 파일이 선택되었습니다.</h3>
      <p className="space-5x">선택된 로고를 업로드하여 이메일 스타일 설정을 진행해 주세요.</p>
      <div className="LogoImageInfoView__image">
        <img alt="로고 이미지" src={base64} onLoad={onLoad} />
      </div>
      <UploadedFileInformation fileName={fileName} onReset={onReset} />
    </div>
  );
}

LogoImageInfoView.propTypes = propTypes;
LogoImageInfoView.defaultProps = defaultProps;

export default LogoImageInfoView;
